import React from 'react';
import { Button, Icon } from 'antd';

import { Wrapper } from './style';

const DomainWarning = ({ handleClose }) => {
    return (
        <Wrapper>
            <div className="warning-container">
                <div className="warning-title">
                    <Icon
                        type="info-circle"
                        style={{ fontSize: '38px', color: '#00f', marginRight: '0.5rem' }}
                    />
                    <span className="title">Updating your domain</span>
                </div>
                <div>
                    <div className="warning-content">In order to update your domain your exchange will need to be restarted. During the restart your exchange will become inaccessible.</div>
                    <div className="warning-content"> Are you sure you want to proceed with the domain update procedure?</div>
                </div>
                <div className="btn-container">
                    <Button
                        type="primary"
                        onClick={handleClose}
                    >
                        Proceed
                    </Button>
                </div>
            </div>
        </Wrapper>
    );
}

export default DomainWarning;
